import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Button from "../../Button"
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import MaskedInput from "react-text-mask";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControlLabel } from "@material-ui/core/";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import { Helmet } from "react-helmet";
import styled from 'styled-components'
import { PAYMENT_TYPE, ACCOUNT_TYPE } from '../../../../constants'
import selectAccountFlagsContainer from "../../../selectors/accountFlags";
import {
  RootContainer,
  Container,
  Header,
  OptionsContainer,
  CreditInformationForm,
  TwoColumnsContainer,
  TextFieldInput,
  ButtonInput,
  TextFieldLabel,
  MakePaymentContainer,
  PaymentMethodHeader,
  SaveCardContainer,
} from "./OneTimeCardPayment.style";

const CreditCardMaskComponent = (props) => {
  const { inputRef, value, ...other } = props;

  const getMask = (cardNumber) => {
    if (detectCardType(cardNumber.replace(/[^\d]/g, "")) === 'Amex') {
      return [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ];
    } else {
      return [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ];
    }
  };

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={getMask(value || "")}
      placeholderChar={"\u2000"}
      guide={false}
    />
  );
}

const CVCMaskComponent = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={"\u2000"}
      guide={false}
    />
  );
}

const ExpiryMaskComponent = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={"\u2000"}
      guide={false}
    />
  );
}

const ZipMaskComponent = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={"\u2000"}
      guide={false}
    />
  );
}

export const ChasePaymentScripts = ({ getKeysUrl }) => (
  <>
    <Helmet>
      <script src={getKeysUrl} />
      <script src={process.env.REACT_APP_CHASE_ENRCRYPTION_URL} />
    </Helmet>
  </>
);

const PaymentButtonContainer = styled.div`
  margin-left: 25px;  
  margin-top: 25px;
`

const PaymentTypeButton = styled.div`
  margin-right: 10px;
  border: 1px solid lightgrey;
  border-radius: 30px;
  padding: 15px;
  font-size: 1rem;
  font-weight: 500;
  color: ${props => (props.selected ? "primary" : "secondary")};
`

const detectCardType = (number) => {
  const re = {
    electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
    maestro:
      /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
    dankort: /^(5019)\d+$/,
    interpayment: /^(636)\d+$/,
    unionpay: /^(62|88)\d+$/,
    Visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
    MasterCard:
      /^5[1-5]\d{14}$|^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d\d|7(?:[01]\d|20))\d{12}$/,
    Amex: /^3[47][0-9]{13}$/,
    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    Discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
    JCB: /^(?:2131|1800|35\d{3})\d{11}$/,
  };

  for (const key in re) {
    if (re[key].test(number)) {
      return key;
    }
  }
};

const PaymentMethodSelector = ({ isCCSelected, setIsCCSelected, disableACHPayment }) => {  
  return (
    <PaymentButtonContainer>    
      <RadioGroup        
        defaultValue={isCCSelected}
        name="paymentType"
        onChange={(e) => {            
          setIsCCSelected(e.target.value === "true")            
        }}
        value={isCCSelected}
        row
      >
        <FormControlLabel
          value={true}
          control={<Radio inline/>}
          label="Credit Card"
        />
        <FormControlLabel
          value={false}
          control={<Radio inline/>}
          label="Bank Account"
          disabled={disableACHPayment}
        />
      </RadioGroup>        
    </PaymentButtonContainer>
    
  )
}

const OneTimeCardPayment = ({
  userID,
  memberID,
  market,
  open,
  onClose,
  onMakeOneTimePayment,
  onFetchMemberAccountBalance,  
  selectedAccountFlags,
  creditCardFee,
  paymentProvider,
}) => {  
  const [amount, setAmount] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [cvc, setCvc] = useState("");
  const [expiry, setExpiry] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [savePaymentCard, setSavePaymentCard] = useState(false);
  const [savePaymentCardAsDefault, setSavePaymentCardAsDefault] = useState(true);
  const [isCCSelected, setIsCCSelected] = useState(true)
  const [accountType, setAccountType] = useState(ACCOUNT_TYPE.checking)
  const [accountNumber, setAccountNumber] = useState("");
  const [routingNumber, setRoutingNumber] = useState("");  
  const [error, setError] = useState("");
  const removeMask = (number) => number && number.replace(/[^\d]/g, "");     
  const disableACHPayment = selectedAccountFlags.some(
    (f) => f.flag_type === "DISABLE_ACH"
  );
  if (disableACHPayment && !isCCSelected) {
    setIsCCSelected(true);
  }

  
    // script loading
    useEffect(() => {
      const script = document.createElement("script");
      script.src = process.env.REACT_APP_FORTE_SCRIPT_URL;
      script.async = true;
      document.body.appendChild(script);    
    },[]);


  const validateInput = () => {
    const amountValid = Boolean(amount && parseFloat(amount));
    const firstNameValid = Boolean(firstName);
    const lastNameValid = Boolean(lastName);  
    const cardNumberScrubbed = removeMask(cardNumber);
    const cardType = detectCardType(cardNumberScrubbed);
    const cardNumberValid = cardType === 'Amex' ? cardNumberScrubbed.length === 15 : cardNumberScrubbed.length === 16;
    const cvcValid = cvc.length === 3 || cvc.length === 4;
    const zipCodeValid = zipCode.length === 5;
    const expiryValid = expiry.length === 7;    
    const accountNumberValid = accountNumber.length >= 5;
    const routingNumberValid = routingNumber.length > 7;    
    return (
      (amountValid || savePaymentCard) &&
      (isCCSelected &&
      firstNameValid &&
      lastNameValid &&
      cardNumberValid &&
      cvcValid &&
      zipCodeValid &&
      expiryValid
      ) || (
        !isCCSelected &&
        firstNameValid &&
        lastNameValid &&
        accountNumberValid &&
        routingNumberValid &&
        zipCodeValid
      )
    );
  };

  const clearForm = () =>{
    setAmount("");
    setFirstName("");
    setLastName("");
    setCardNumber("");
    setCvc("");
    setExpiry("");
    setZipCode("");
  }

  const processPayment = async () => {    
    const timestamp = new Date().getTime();
    const reqBody = {
      memberID,
      market,
      order_id: `MP${userID}_${timestamp}`,
      firstName,
      lastName,
      zip: zipCode,
      amount: amount || "0",
      is_default: savePaymentCardAsDefault,
      skip_saving_profile: !savePaymentCard,
    };    
    
    if(isCCSelected){
      const cardNumberScrubbed = removeMask(cardNumber);
      const exp = expiry.split("/");
      reqBody.payment_type = detectCardType(cardNumber);

      // encrypt card

      let data    
    // using forte integration, get data directly from form state
    // use forte js to tokenize card on client side  
    try {
      const fortePayload = {
        api_login_id: process.env.REACT_APP_FORTE_API_LOGIN_ID,
        card_number: cardNumberScrubbed,
        expire_year: expiry.substring(3, 7),
        expire_month: expiry.substring(0, 2),
        cvv: cvc,
      }
      console.log("fortePayload", fortePayload)
      if (!window.forte || typeof window.forte.createToken !== 'function') {
        // will be caught below
        throw new Error('unable to load Forte SDK');
      }     
      data = await new Promise((resolve, reject) => {
        window.forte.createToken(fortePayload)
          .success(resolve)
          .error(reject);
      });
      setError(null);
    } catch (err) {
      console.error('Forte integration error:', err)
      setError(err.response_description || 'There was an issue processing your payment, please try again.');
      // will handle null  data below
      data = null
    }

    if (!data) {
      console.error('There was an issue processing your payment, please try again.')
      return false;
      
    }

    const success = data?.event === 'success'
    if (!success) {
      console.error("There was an issue processing your payment, please try again.")
      return
    }    
    const { onetime_token, expire_month, expire_year, last_4 } = data

      reqBody.payment_type = detectCardType(cardNumberScrubbed);
      
      reqBody.credit_card_info = {
        cardNumber: onetime_token+last_4, // sending last 4 digits along with token as expected by backend
        cvc: cvc,
        expiration_month: expire_month,
        expiration_year: expire_year,
      };
    }else{
      reqBody.payment_type = PAYMENT_TYPE.ECP
      reqBody.bank_info = {
        account_type: accountType,
        account_number: accountNumber,
        routing_number: routingNumber,
      }
    }
    
    onClose();
    onMakeOneTimePayment(memberID, "amount", amount, reqBody).then(() => {
      clearForm();      
      onFetchMemberAccountBalance(memberID);
    });
     
  };
  return (
    <Dialog
      onClose={() => onClose()}
      aria-labelledby="on time payment dialog"
      open={open}
    >
      <RootContainer>
        <Container variant="outlined">
          <Header>
            <span>One Time Payment</span>
            <CloseIcon onClick={() => onClose()} />
          </Header>
          <input type="hidden" value="_" />
          <MakePaymentContainer>            
            <h4>Make Payment</h4>
            <TextFieldInput
              label={`Amount`}
              onChange={(e) => setAmount(e.target.value)}
              value={amount}
              type="money"
              required
              InputLabelProps={{
                shrink: true,
              }}
              autoComplete="off"
            />
            </MakePaymentContainer>
          <PaymentMethodSelector
            isCCSelected={isCCSelected}
            setIsCCSelected={setIsCCSelected}
            disableACHPayment={disableACHPayment}
          />
          { isCCSelected && <CreditInformationForm autoComplete="off">
            
            <PaymentMethodHeader>Credit Card Information</PaymentMethodHeader>
            <TextFieldInput
              label={`First Name`}
              onChange={(e) => setFirstName(e.target.value)}
              value={firstName}
              type="text"
              required
              InputLabelProps={{
                shrink: true,
              }}
              autoComplete="off"
            />
            <TextFieldInput
              label={`Last Name`}
              onChange={(e) => setLastName(e.target.value)} 
              value={lastName}
              type="text"
              required
              InputLabelProps={{  
                shrink: true,
              }}
              autoComplete="off"
            />
            <TextFieldLabel>Card number *</TextFieldLabel>
            <TextFieldInput
              label=""
              onChange={(e) => setCardNumber(e.target.value)}
              value={cardNumber}
              type="text"
              required
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputComponent: CreditCardMaskComponent,
              }}
              autoComplete="off"
            />
            <TwoColumnsContainer>
              <TextFieldInput
                label={`CVC`}
                onChange={(e) => setCvc(e.target.value)}
                value={cvc}
                type="text"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputComponent: CVCMaskComponent,
                }}
                style={{ width: "48%" }}
                autoComplete="off"
              />
              <TextFieldInput
                label={`Expiry Date`}
                onChange={(e) => setExpiry(e.target.value)}
                value={expiry}
                type="text"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputComponent: ExpiryMaskComponent,
                }}
                style={{ width: "48%" }}
                autoComplete="off"
              />
            </TwoColumnsContainer>
            <TextFieldInput
              label={`Zip Code`}
              onChange={(e) => setZipCode(e.target.value)}
              value={zipCode}
              type="text"
              required
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputComponent: ZipMaskComponent,
              }}
              style={{ width: "48%" }}
              autoComplete="off"
            />            
            {Boolean(creditCardFee) && <span style={{ color: "red", marginTop:"10px" }}>
              {creditCardFee}% processing fee will apply to credit card payments
            </span>}
          </CreditInformationForm>
          }
          { !isCCSelected && <CreditInformationForm>
            <PaymentMethodHeader>Bank Account Information</PaymentMethodHeader>
            <TextFieldInput
                select
                label={'Account Type'}
                name="accountType"
                type="tel"
                mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
                guide={false}
                autoComplete="postal-code"
                defaultValue={ACCOUNT_TYPE.checking}
                onChange={(e) => setAccountType(e.target.value)}
              >
                <MenuItem value={ACCOUNT_TYPE.checking} >
                  {ACCOUNT_TYPE.checking}
                </MenuItem>
                <MenuItem value={ACCOUNT_TYPE.savings} >
                  {ACCOUNT_TYPE.savings}
                </MenuItem>
                <MenuItem value={ACCOUNT_TYPE.commercialChecking} >
                  {ACCOUNT_TYPE.commercialChecking}
                </MenuItem>
              </TextFieldInput> 

            <TextFieldInput
                label={'First Name'}
                name="firstName"
                autoComplete="name"
                maxLength={30}            
                onChange={(e) => setFirstName(e.target.value)}    
                InputLabelProps={{
                  shrink: true,
                }}
            />
            
            <TextFieldInput
                label={'Last Name'}
                name="lastName"
                autoComplete="name"
                maxLength={30}            
                onChange={(e) => setLastName(e.target.value)}    
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <TextFieldInput
                label={'Account Number'}
                name="accountNumber"
                autoComplete="accountNumber"
                type="tel"
                maxLength={17}
                onChange={(e) => setAccountNumber(e.target.value)}
                mask={[
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                guide={false}
                InputLabelProps={{
                  shrink: true,
                }}
              />              
             <TwoColumnsContainer>
              <TextFieldInput
                label={'Routing Number'}
                name="routingNumber"
                type="tel"
                autoComplete="routingNumber"
                maxLength={9}
                onChange={(e) => setRoutingNumber(e.target.value)}
                mask={[
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                guide={false}
                InputLabelProps={{
                  shrink: true,
                }}
                // prettier-ignore
              />                                                                 

              <TextFieldInput
                label={'Zip Code'}
                name="zipcode"
                type="tel"
                mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
                onChange={(e) => setZipCode(e.target.value)}
                guide={false}
                autoComplete="postal-code"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </TwoColumnsContainer>
            </CreditInformationForm>}            
            <SaveCardContainer>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={savePaymentCard}
                    onChange={(e) => setSavePaymentCard(e.target.checked)}                  
                  />
                }
                label={`Save payment card`} 
              />
            <FormControlLabel
              control={
                <Checkbox
                  checked={savePaymentCard && savePaymentCardAsDefault}
                  onChange={(e) => setSavePaymentCardAsDefault(e.target.checked)}    
                  disabled={!savePaymentCard}              
                />
              }
              label={`Make default payment card`} 
              style={{ marginTop: "15px" }}
            />            
          </SaveCardContainer>
          {error && <span style={{ color: "red", margin:"15px" }}>{error}</span>}
          <OptionsContainer>
            <Button color="secondary" variant="raised" onClick={() => onClose()}>
              Cancel
            </Button>
            <ButtonInput
              disabled={!validateInput()}
              color="primary"
              variant="raised"
              onClick={async () => await processPayment()}
            >
              Process
            </ButtonInput>
          </OptionsContainer>
        </Container>
      </RootContainer>
    </Dialog>
  );
};

const mapStateToProps = selectAccountFlagsContainer();

const ConnectedOneTimeCardPayment = connect(
    mapStateToProps,
    {},
)(OneTimeCardPayment);

export default ConnectedOneTimeCardPayment;